<style lang="scss" type="text/scss">
    .team-entry-container {
        .info-panel {
            margin-bottom: 1rem;
        }
    }
</style>


<template>
    <div class="team-entry-container">
        <block-divider>搜索参赛队</block-divider>
        <info-panel class="info-panel">申请加入参赛队前，必须完善基本信息，并将身份选择为学生/教师</info-panel>
        <search-box @need-reload="afterApply" :entered="personalEnteredPlayers"
                    :unfinished="unfinishedContestantApplications"></search-box>

        <block-divider>开放报名中的赛事</block-divider>
        <registrable-competitions></registrable-competitions>

        <block-divider>已申请的参赛队</block-divider>
        <info-panel class="info-panel">申请成功后，可以在「我的参赛」中查看参赛信息；若申请被驳回，系统会向您发送站内信通知</info-panel>
        <contestant-applications :data="contestantApplications" :loading="contestantApplicationRequesting">
        </contestant-applications>
    </div>
</template>

<script>
    import BlockDivider from '../../../../components/divider/block';
    import InfoPanel from '../../../../components/info-panel';
    import RegistrableCompetitions from './registrable-competitions';
    import ContestantApplications from './contestant-applications';
    import SearchBox from './search-box';
    import {handleContestantApplications, handlePlayers} from '../../../../utils/data-handler';

    export default {
        name: '',
        components: {
            BlockDivider,
            InfoPanel,
            RegistrableCompetitions,
            ContestantApplications,
            SearchBox
        },
        created () {
            this.loadPersonalUnfinishedContestantApplications();
            this.loadPersonalContestantApplications();
            this.loadPersonalEnteredPlayers();
        },
        data () {
            return {
                unfinishedContestantApplications: [],
                contestantApplications: [],
                personalEnteredPlayers: [],
                contestantApplicationRequesting: false,
                unfinishedContestantApplicationRequesting: false
            };
        },
        computed: {},
        methods: {
            afterApply (callback) {
                this.loadPersonalUnfinishedContestantApplications().then(_ => {
                    callback();
                });
                this.loadPersonalContestantApplications().then(_ => {
                    callback();
                });
            },
            loadPersonalUnfinishedContestantApplications () {
                return this.$normalRequest('player/loadPersonalUnfinishedContestantApplications', {}, false, false, this, 'unfinishedContestantApplicationRequesting').then(data => {
                    this.unfinishedContestantApplications = handleContestantApplications(data);
                }).catch(_ => {
                });
            },
            loadPersonalContestantApplications () {
                return this.$normalRequest('player/loadPersonalContestantApplications', {}, false, false, this, 'contestantApplicationRequesting').then(data => {
                    this.contestantApplications = handleContestantApplications(data);
                }).catch(_ => {
                });
            },
            loadPersonalEnteredPlayers () {
                this.$normalRequest('player/loadPersonalEnteredPlayers', {}, null).then(data => {
                    this.personalEnteredPlayers = handlePlayers(data);
                }).catch(_ => {
                });
            }
        }
    };
</script>
